import initCardsSection from "../Components/Sections/AdvantageCardsSection";
import "Styles/Pages/HubLocatorLP.scss";

initCardsSection();